import React from 'react';

import { Flex, FlexProps, Stack, Text } from '@mantine/core';

import { Page } from './Page';

interface Props {
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    children?: React.ReactNode;
    maxWidth?: number;
    padding?: FlexProps['p'];
}

export const CenteredContent = ({ title, subtitle, children, maxWidth = 640, padding = 'xl' }: Props) => {
    return (
        <Flex
            align="center"
            justify="center"
            gap="lg"
            direction="column"
            p={padding}
            style={{
                width: '100%',
                maxWidth,
                height: '100%',

                flexGrow: 1,

                marginLeft: 'auto',
                marginRight: 'auto',
            }}
        >
            <Stack gap="xs">
                {title && (
                    <Page.Title ta="center" maw={maxWidth}>
                        {title}
                    </Page.Title>
                )}
                {subtitle && (
                    <Text ta="center" c="dimmed" fw={500} maw={maxWidth}>
                        {subtitle}
                    </Text>
                )}
            </Stack>
            {children}
        </Flex>
    );
};
